import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZocdoc = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "2 2 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
			fill: "#FEED5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0061 16.997C11.0341 16.997 10.0725 16.8097 9.17277 16.4439L8.75684 16.2684V15.5457L13.7922 8.08111H8.78633V7.00146H15.2362V7.87315L10.0208 15.6062C10.6624 15.8141 11.3321 15.9189 12.0061 15.9189C13.13 15.9189 14.2362 15.6327 15.22 15.09L15.7436 16.0354C14.6005 16.6681 13.3144 17 12.0076 17L12.0061 16.997Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.00707 12.5369C9.42088 12.5369 9.75634 12.2014 9.75634 11.7876C9.75634 11.3738 9.42088 11.0383 9.00707 11.0383C8.59327 11.0383 8.25781 11.3738 8.25781 11.7876C8.25781 12.2014 8.59327 12.5369 9.00707 12.5369Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9954 12.5369C15.4092 12.5369 15.7446 12.2014 15.7446 11.7876C15.7446 11.3738 15.4092 11.0383 14.9954 11.0383C14.5815 11.0383 14.2461 11.3738 14.2461 11.7876C14.2461 12.2014 14.5815 12.5369 14.9954 12.5369Z",
			fill: "#333333"
		})
	]
});
const ForwardRef = forwardRef(SvgZocdoc);
export { ForwardRef as ReactComponent };
